import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-gray container-fix-padding"
}
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "ms-3 gray--text" }
const _hoisted_5 = {
  key: 1,
  class: "float-right exam-price"
}
const _hoisted_6 = { class: "mt-2 mb-0" }
const _hoisted_7 = { class: "d-flex" }

import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { LETTER_FORMAT } from '../../utils/constants'
import Exam from '../../models/exam'
import { examState } from '../../stores/exam'
import { headerState } from '../../stores/header'
import { footerState } from '../../stores/footer'
import { ROUTER_NAME } from '../../router'
import { format } from 'date-fns'


export default /*@__PURE__*/_defineComponent({
  __name: 'ExamRecommendationList',
  setup(__props) {

const router = useRouter()
const route = useRoute()

const isMobile = ref(false)
const drawer = ref(false)

const exams = computed(() => examState.listRecommendationExam.list)
const isLoading = computed(() => examState.listRecommendationExam.isLoading)
const pagination = computed(() => examState.listRecommendationExam.pagination)
const currentExams = computed((): Exam[] => exams.value)
const title = computed(() => 'すべてのテスト')

const selectPage = (page: number) => {
  examState.getList(page)
}

const onResize = () => {
  isMobile.value = window.innerWidth < 600
}

const dateFormat = (date: Date | string) => {
  return format(new Date(date), 'YYYY/MM/DD HH:mm')
}

onMounted(async () => {
  await examState.getRecommendationList()
  headerState.setTitle('テスト一覧')
  footerState.setFooterDefault()
  onResize()
  window.addEventListener('resize', onResize)
})

onBeforeUnmount(() => {
  if (typeof window !== 'undefined') {
    window.removeEventListener('resize', onResize)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (!isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_col, {
            lg: "9",
            cols: "12",
            class: "exam-list pt-0"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_v_col, {
                  cols: "8",
                  class: "p-0"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", _hoisted_4, _toDisplayString(title.value), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }),
                (isMobile.value)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "4",
                      class: "text-end pt-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          class: "me-2",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (drawer.value = !drawer.value), ["stop"]))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                _createTextVNode("exit_to_app", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }),
                            _cache[3] || (_cache[3] = _createTextVNode("カテゴリー ", -1 /* CACHED */))
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true)
              ]),
              _createVNode(_component_v_list, { "three-line": "" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentExams.value, (exam, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: exam.id
                    }, [
                      _createVNode(_component_v_list_item, {
                        to: `/classroom/exam-list/${exam.id}`,
                        class: _normalizeClass({ 'px-0': isMobile.value })
                      }, _createSlots({
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              (exam.price > 0)
                                ? (_openBlock(), _createBlock(_component_v_chip, {
                                    key: 0,
                                    color: "orange",
                                    "text-color": "white",
                                    label: ""
                                  }, {
                                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                      _createTextVNode("有料", -1 /* CACHED */)
                                    ]))]),
                                    _: 1 /* STABLE */
                                  }))
                                : _createCommentVNode("v-if", true),
                              _createTextVNode(" " + _toDisplayString(exam.name) + " ", 1 /* TEXT */),
                              (exam.price > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(exam.price.toLocaleString()) + "円", 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */),
                          _createVNode(_component_v_list_item_subtitle, null, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_6, [
                                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "mt-n2" }, "レベル", -1 /* CACHED */)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from(Array(exam.difficultRate).keys()), (item, index) => {
                                  return (_openBlock(), _createElementBlock("img", {
                                    key: index,
                                    style: {"width":"20px"},
                                    class: "icon",
                                    src: "/images/icons/theme/general/star.svg",
                                    "data-inject-svg": ""
                                  }))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]),
                              _createElementVNode("div", _hoisted_7, [
                                _createVNode(_component_v_col, { lg: "3" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(dateFormat(exam.createdAt)), 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */),
                                _createVNode(_component_v_col, { lg: "3" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("合格率 " + _toDisplayString(exam.passRate) + "%", 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */),
                                _createVNode(_component_v_col, { lg: "3" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("平均 " + _toDisplayString(exam.averageRate) + "%", 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */)
                              ])
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, [
                        (!isMobile.value)
                          ? {
                              name: "prepend",
                              fn: _withCtx(() => [
                                _createVNode(_component_v_img, {
                                  "min-height": "100",
                                  "min-width": "100",
                                  "max-height": "100",
                                  "max-width": "100",
                                  src: exam.image && exam.image.url ? exam.image.url : exam.examImageUrl
                                }, null, 8 /* PROPS */, ["src"])
                              ]),
                              key: "0"
                            }
                          : undefined
                      ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["to", "class"]),
                      _createVNode(_component_v_divider, { class: "my-0" })
                    ], 64 /* STABLE_FRAGMENT */))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }),
              (exams.value.length > 0)
                ? (_openBlock(), _createBlock(_component_v_pagination, {
                    key: 0,
                    modelValue: pagination.value.page,
                    "onUpdate:modelValue": [
                      _cache[1] || (_cache[1] = ($event: any) => ((pagination.value.page) = $event)),
                      selectPage
                    ],
                    length: pagination.value.totalPages,
                    class: "mt-4 mb-5"
                  }, null, 8 /* PROPS */, ["modelValue", "length"]))
                : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          })
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})